import { useTranslation } from "react-i18next";
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

function Logout({
  isAuthenticated
}) {
  const {
    t
  } = useTranslation();

  if (!isAuthenticated) {
    return null;
  }

  return <Link to={{
    pathname: '/logout',
    state: {
      logout: true
    }
  }} className='nav-link'>{t("Logout")}</Link>;
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default withRouter(connect(mapStateToProps)(Logout));